"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateClientIntegrationSettingsMutation = exports.useFetchClientQuery = exports.useRegisterMutation = exports.clientApi = void 0;
// api/clientApi.ts
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.clientApi = (0, react_1.createApi)({
    reducerPath: "clientApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.LETS_CUE_API),
    tagTypes: ["client"],
    endpoints: function (builder) { return ({
        register: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/client/register",
                method: "POST",
                body: obj,
            }); },
            invalidatesTags: ["client"],
        }),
        fetchClient: builder.query({
            query: function (clientId) { return ({
                url: "/v1/client/fetch",
                method: "GET",
                params: { _id: clientId },
            }); },
            providesTags: ["client"],
        }),
        updateClientIntegrationSettings: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/client/update",
                method: "PUT",
                body: obj,
            }); },
            invalidatesTags: ["client"],
        }),
    }); },
});
exports.useRegisterMutation = exports.clientApi.useRegisterMutation, exports.useFetchClientQuery = exports.clientApi.useFetchClientQuery, exports.useUpdateClientIntegrationSettingsMutation = exports.clientApi.useUpdateClientIntegrationSettingsMutation;
